import type {
  VacationCredit,
  VacationCreditCommitResponse,
  VacationCreditCommitResponseDto,
  VacationCreditDto,
} from '@src/features/users/types';

export function vacationCreditFromDto(dto: VacationCreditDto): VacationCredit {
  return {
    id: dto.id,
    version: dto.version,
    date: dto.vacr_date,
    days: String(dto.vacr_days),
    notes: dto.vacr_notes ?? '',
    isSystemGenerated: dto.is_system_generated,
  };
}

export function vacationCreditCommitResponseFromDto(
  response: VacationCreditCommitResponseDto,
): VacationCreditCommitResponse {
  return {
    requiresConfirmation: response.requires_confirmation,
    results: (response.results ?? []).map(vacationCreditFromDto),
  };
}
